/*
 * Copyright (c) 2020 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {  NotificationProps } from "common/types/Notification";

const initialState: NotificationProps[] = [];

export const notificationSlice = createSlice({
    initialState,
    name: "notification",
    reducers: {
        dequeueNotification: (state, action: PayloadAction<string | undefined>) => {
            if (action.payload) {
                // Remove notification by ID
                state = state.filter((notification: NotificationProps) => notification.message !== action.payload);
            } else {
                // Remove last notification
                state.splice(-1);
            }
        },
        enqueueNotification: (state, action: PayloadAction<NotificationProps>) => {
            state.push(action.payload);
        },
    },
});

// Selector
export const selectNotifications = (state: NotificationProps[]) => state;

// Actions
export const { enqueueNotification, dequeueNotification } = notificationSlice.actions;

// Reducer
export default notificationSlice.reducer;
